// Provvedimenti della giustizia sportiva.
// I file PDF vanno in /app/frontend/public/giustizia/
export const PROVVEDIMENTI = [
  {
    title: "Provvedimento n°1 — City Padel Blue / La Romita Azzurra",
    desc: "Decisione ufficiale della giustizia sportiva del campionato.",
    file: "provvedimento-1-city-padel-blue-la-romita-azzurra.pdf",
  },
];
